<script>
import options from "./ShopFilterContainer.options";
export default options;
</script>

<template>
    <div class="nti-shop-filter-container">
        <ShopFilter />
    </div>
</template>




